// 保存试听反馈内容
export const DEMOCLASS_SAVE_INFO = 'DEMOCLASS_SAVE_INFO';



// WEBPACK FOOTER //
// ./src/views/index/store/types/types_democlass.js